<template lang='pug'>
  r-table(
    no-data-text='Sin facturas.'
    no-remove
    param-search='number'
    ref='table'
    v-bind='tableProps'
    @detail='submitDetail'
    )
    template( 
      slot='actions' 
      slot-scope='props' 
      )
      r-btn-action( 
        color='dark'
        :disabled='!props.item.is_invoice'
        tooltip='PDF'
        @click='submitPrint(props)' 
        )
        v-icon picture_as_pdf
    template( slot='items' )
      r-dialog( 
        content-class='grey lighten-3'
        no-confirm
        title='Nota de debito'
        v-model='dialogs.debit' 
      )
        r-form(
          class='white'
          no-submit
          reset-text='cerrar'
          v-bind='formDebitNoteProps'
          v-model='selected'
          @reset='toggleDialog("debit")'
        )

      r-dialog( 
        content-class='grey lighten-3'
        no-confirm
        title='Factura de venta'
        v-model='dialogs.invoice' 
      )
        r-form(
          class='white'
          no-submit
          reset-text='cerrar'
          v-bind='formInvoiceProps'
          v-model='selected'
          @reset='toggleDialog("invoice")'
        )
</template>

<script>
  //
  import { RBtnAction, RDialog, RForm, RTable } from '@/components/reusable_components/next'
  //
  import SlCustomerAccountReceivableHeaders from '@/views/Sale/SlCustomerAccountReceivable/SlCustomerAccountReceivableHeaders'
  import SlCustomerAccountReceivableFilters from '@/views/Sale/SlCustomerAccountReceivable/SlCustomerAccountReceivableFilters'
  import SlCustomerAccountReceivableService from '@/services/api/Sale/SlCustomerAccountReceivable'
  //
  import SaleInvoiceFields from '@/views/Sale/SlSaleInvoice/SlSaleInvoiceFields'
  import SaleDebitNoteFields from '@/views/Sale/SlSaleDebitNote/SlSaleDebitNoteFields'
  //
  export default {
    components: {
      RBtnAction,
      RDialog,
      RForm,
      RTable,
    },
    computed: {
      /**
       * { function_description }
       * @return     {Object}  { description_of_the_return_value }
       */
      formDebitNoteProps() {
        return {
          fields: SaleDebitNoteFields.variant('update').readonly(),
        }
      },
      /**
       * { function_description }
       * @return     {Object}  { description_of_the_return_value }
       */
      formInvoiceProps() {
        return {
          fields: SaleInvoiceFields.readonly(),
        }
      },
      tableProps() {
        return {
          filters: SlCustomerAccountReceivableFilters
            .exclude(['number', 'recent'])
            .prop('sl_customer_branch_offices_id', {
              noAsyncSearch: true, 
              paramFilter: { 
                sl_customer_id: this.$route.params.id 
              },
            }),
          headers: SlCustomerAccountReceivableHeaders,
          //  .get('customer_detail'),
          service: SlCustomerAccountReceivableService,
          paramFilter: {
            sl_customer_id: this.$route.params.id,
            status: 'atrasado',
          },
        }
      },
    },
    data() {
      return {
        dialogs: {
          invoice: false,
          debit: false,
        },
        selected: null,
      }
    },
    methods: {
      /**
       * Fetches the given item.
       * @param      {<type>}  item    The item
       * @return     {<type>}  { description_of_the_return_value }
       */
      fetch(item) {
        return item.is_invoice ? item.fetch('sl_sale_invoice') : item.fetch('sl_sale_debit_note')
      },
      /**
       * Gets the pdf.
       * @param      {<type>}  item    The item
       */
      getPdf(item) {
        item.toPdf()
      },
      /**
       * Sets the selected.
       * @param      {<type>}  item    The item
       */
      setSelected(item) {
        this.selected = item.reset()
      },
      /**
       * { function_description }
       * @param      {<type>}  event   The event
       */
      submitDetail(event) {
        this.toggleDialog(event.item.is_invoice ? 'invoice' : 'debit')
        this.fetch(event.item).then(this.setSelected)
      },
      /**
       * { function_description }
       * @param      {<type>}  event   The event
       */
      submitPrint(event) {
        this.fetch(event.item).then(this.getPdf)
      },
      /**
       * { function_description }
       * @param      {<type>}  dialogName  The dialog name
       */
      toggleDialog(dialogName) {
        this.dialogs[dialogName] ^= 1
      },
    },
  }
</script>
